import styles from './taskComponent.module.css'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { TaskForm } from './TaskForm'
import { Box } from '@mui/material'

export const EditTaskModal = ({ task, setEditingTask }) => {
	const dispatch = useDispatch()

	const [form, setForm] = useState({
		name: '',
		type: '',
		assignedUsers: [],
		ableToView: [],
		eventTags: [],
	})

	const handleSubmit = (updates) => {
		// dispatch(editTask({ taskId: task._id, updates }))
		setEditingTask(null)
	}

	const handleClose = () => {
		setEditingTask(null)
	}

	// useEffect(() => {
	// 	setForm(task)
	// }, [dispatch, task?._id])

	return (
		<div className={styles.overlay}>
			<form className={styles.modal} onSubmit={() => handleSubmit(form)}>
				<h2>Edit Task</h2>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
					}}
				>
					<TaskForm task={form} setTask={setForm} />
				</Box>

				<button type="submit" data-cy="saveTaskButton">
					Save
				</button>
				<button type="button" onClick={handleClose}>
					Close
				</button>
			</form>
		</div>
	)
}
